import { FC } from 'react';
import cn from 'classnames';

import { PropsWithClassName } from '@app/constants';

import css from './Image.module.scss';

interface ImageProps {
  src: string;
  altText: string;
}

export const Image: FC<PropsWithClassName<ImageProps>> = ({
  src,
  altText,
  className,
}) => {
  return <img src={src} alt={altText} className={cn(css.image, className)} />;
};
